import React from 'react'
import { Create, SaveButton, SimpleForm, TextInput, Toolbar, translate } from 'react-admin'
import { containsRestrictedFieldName } from '../models/restrictedNames'

const SaveOnlyToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton disabled={props.invalid} />
  </Toolbar>
)

const AssetTypeCreate = ({ accessible, dispatch, recordLiveValues, roles, translate, ...props }) => {
  const toolbar = <SaveOnlyToolbar />
  const validateName = (value) =>
    !containsRestrictedFieldName(value) ? undefined : translate('main.restricted_field_name')

  return (
    <Create {...props}>
      <SimpleForm toolbar={toolbar} redirect="list">
        <TextInput source="name" resettable validate={validateName} />
      </SimpleForm>
    </Create>
  )
}

export default translate(AssetTypeCreate)
